import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const LOGO = "https://customer-assets.emergentagent.com/job_admissions-roadmap/artifacts/2ac8oce6_Mindways%20logo.png";

export default function CookiePolicy() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div style={{ minHeight: "100vh", backgroundColor: "#fff" }}>
      <header style={{ backgroundColor: "#2B2F9E", padding: "20px 24px" }}>
        <div style={{ maxWidth: "1280px", margin: "0 auto", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Link to="/">
            <div style={{ backgroundColor: "#fff", borderRadius: "8px", padding: "6px 12px" }}>
              <img src={LOGO} alt="Mindways" style={{ height: "52px", width: "auto", display: "block" }} />
            </div>
          </Link>
          <Link to="/" style={{ color: "rgba(255,255,255,0.85)", fontFamily: "'DM Sans', sans-serif", fontSize: "14px", fontWeight: "600", textDecoration: "none" }}>
            &larr; Back to Home
          </Link>
        </div>
      </header>

      <main style={{ maxWidth: "800px", margin: "0 auto", padding: "64px 24px" }}>
        <span style={{ fontSize: "13px", fontWeight: "700", letterSpacing: "0.12em", textTransform: "uppercase", color: "#F5A000", fontFamily: "'DM Sans', sans-serif" }}>Legal</span>
        <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: "clamp(28px, 4vw, 42px)", fontWeight: "700", color: "#0F172A", margin: "12px 0 8px", lineHeight: "1.2" }}>Cookie Policy</h1>
        <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: "14px", color: "#94A3B8", marginBottom: "48px" }}>Last updated: February 2026</p>

        {[
          {
            title: "1. What Are Cookies",
            body: "Cookies are small text files placed on your device when you visit a website. They help the website remember your preferences, analyse traffic, and provide certain features. Cookies cannot run programmes or deliver viruses to your device.",
          },
          {
            title: "2. How We Use Cookies",
            body: "Mindways uses cookies to: understand how visitors use our website (analytics); remember your preferences during a session; and enable third-party tools such as Google Analytics. We do not use cookies for advertising or to track you across other websites.",
          },
          {
            title: "3. Types of Cookies We Use",
            body: "Essential cookies: Required for the website to function. These cannot be disabled. Analytics cookies: We use Google Analytics to understand visitor behaviour (pages visited, time on site, referring source). These are anonymised and aggregated. Session cookies: Temporary cookies that expire when you close your browser. They help the site function during your visit.",
          },
          {
            title: "4. Third-Party Cookies",
            body: "Some cookies are set by third-party services that appear on our pages. These include Google Analytics and Cal.com (our booking tool). We do not control these cookies. Please refer to their respective privacy and cookie policies for more information.",
          },
          {
            title: "5. Managing Cookies",
            body: "You can control and manage cookies through your browser settings. Most browsers allow you to: view cookies stored on your device; delete all or specific cookies; block all cookies or cookies from specific sites; and block third-party cookies. Please note that disabling cookies may affect the functionality of some parts of our website.",
          },
          {
            title: "6. Browser Settings",
            body: "To manage cookies in major browsers: Chrome — Settings > Privacy and Security > Cookies. Firefox — Options > Privacy & Security > Cookies. Safari — Preferences > Privacy > Cookies. Edge — Settings > Privacy, Search and Services > Cookies.",
          },
          {
            title: "7. Changes to This Policy",
            body: "We may update this Cookie Policy from time to time to reflect changes in technology or regulation. The current version will always be available on this page.",
          },
          {
            title: "8. Contact",
            body: "For cookie-related queries, contact us at: study@mindways.in | +91-9821916960 | 1106 Chiranjiv Tower, 43 Nehru Place, New Delhi 110019.",
          },
        ].map((section) => (
          <div key={section.title} style={{ marginBottom: "36px" }}>
            <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: "20px", fontWeight: "700", color: "#0F172A", margin: "0 0 12px" }}>{section.title}</h2>
            <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: "16px", color: "#475569", lineHeight: "1.75", margin: 0 }}>{section.body}</p>
          </div>
        ))}
      </main>

      <div style={{ backgroundColor: "#2B2F9E", padding: "24px", textAlign: "center" }}>
        <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: "13px", color: "rgba(255,255,255,0.6)", margin: 0 }}>
          © {new Date().getFullYear()} Mindways Consulting Pvt. Ltd. · <Link to="/privacy-policy" style={{ color: "rgba(255,255,255,0.6)", textDecoration: "none" }}>Privacy Policy</Link> · <Link to="/terms-of-service" style={{ color: "rgba(255,255,255,0.6)", textDecoration: "none" }}>Terms of Service</Link>
        </p>
      </div>
    </div>
  );
}
